import React, { useState, useEffect, useCallback } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha, DialogContent, Typography } from "@mui/material";
import theme from "src/config/theme";
import ButtonComponent from "src/components/shared/Button";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import { ReactComponent as Edit } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Delete } from '../../../../../assets/images/trash.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';
import { ReactComponent as View } from '../../../../../assets/images/eye.svg';
import { ReactComponent as Share } from '../../../../../assets/images/Share.svg';
import { ReactComponent as Print } from '../../../../../assets/images/printer.svg';
import { ReactComponent as Download } from '../../../../../assets/images/document-download.svg'
import PrescriptionTabForm from "../Forms/PrescriptionTabForm";
import NoDataFound from "../../NoDataFound/NoDataFound";
import { getMedicalRecordsRequest, deleteMedicalRecordRequest } from "src/modules/app/store/appActions";
import { useDispatch, useSelector } from "react-redux";
import { HeaderPart, FooterPart, AvatarIcon, SaveButton } from "../Forms/Style";
import { ReactComponent as CloseIcon } from '../../../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../../src/assets/images/add-square.svg';
import { ReactComponent as Danger } from '../../../../../../src/assets/images/danger.svg'
import { palette, shadows } from 'src/config/theme.js';
import DeleteDialog from "../../DeleteDialog";
import { useNavigate } from 'react-router-dom';
import useResponsive from "src/components/hooks/useResponsive";
import useAppointmentDetails from "../../UseAppointmentDetails";
import { AllTabsMainContainer } from "../Style";
import PrescriptionCard from "../CardView/PrescriptionCard";
import dayjs from "dayjs";
import ViewPrescription from "../ViewPrescription/ViewPrescription";

const columns = [
  { id: "note", label: "Prescriptions", sx: { width: "1200px", minWidth: "150px", textAlign: 'left' } },
  { id: "addedDate", label: "Added Date", sx: { "& .css-axw7ok": { justifyContent: 'center' } } },
  // { id: "addedBy", label: "Added By", sx: { "& .css-axw7ok": { justifyContent: 'center' } } },

];

const Prescription = ({ shouldRefresh }) => {
  const [open, setOpen] = useState(false);
  const [prescription, setPrescription] = useState([])
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState();
  const { PatientId } = useAppointmentDetails();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedPrescriptionId, setSelectedPrescriptionId] = useState(null);
  const [viewMode, setViewMode] = useState(null);

  const handleOpenViewDialog = (prescriptionId, mode = 'view') => {
    setSelectedPrescriptionId(prescriptionId);
    setViewMode(mode);
    setViewDialogOpen(true);
  };

  const handleCloseViewDialog = () => {
    setSelectedPrescriptionId(null);
    setViewMode(null);
    setViewDialogOpen(false);
  };


  const [deletePreId, setDeletePreId] = useState(null);
  const navigate = useNavigate();


  const handleOpenDeleteDialog = (notesId) => {
    setDeletePreId(notesId);
    setOpenDeleteDialog(true);
  };
  const handleCloseDeleteDialog = () => setOpenDeleteDialog(false);





  const fetchPrescription = useCallback(
    (page = 0, perPage = 10) => {
      const fetchData = async () => {
        const params = {
          page: page + 1,
          limit: perPage,
        };

        const response = await new Promise((resolve, reject) => {
          dispatch(getMedicalRecordsRequest({ patientId: PatientId, params }, resolve, reject));
        });

        if (response?.data && response?.meta) {
          const filteredData = response.data.filter(note => note.recordType === 'prescription');
          setPrescription(filteredData);
          setTotalCount(response.meta.totalRecords);

        } else {
          console.log('Error fetching notes');
        }

      }
      fetchData();

    },
    [dispatch, PatientId],
  );

  useEffect(() => {
    if (PatientId) {
      fetchPrescription(page, perPage);
    }
  }, [PatientId, fetchPrescription, page, perPage, shouldRefresh]);

  const data = prescription.map((prescriptionData) => ({
    prescriptionId: prescriptionData?.id,
    note: prescriptionData?.notes,
    addedDate: `${dayjs(prescriptionData.date).format("DD-MM-YYYY")}, ${prescriptionData.time}`,

  }))

  const handleDelete = async (prescriptionId) => {
    if (prescriptionId) {
      try {
        await dispatch(deleteMedicalRecordRequest(prescriptionId));
        console.log("🚀 Dispatching delete action for ID:", prescriptionId);
        setPrescription((prevNotes) => prevNotes.filter(note => note.id !== prescriptionId));
        setOpenDeleteDialog(false);
        console.log('Note deleted successfully');
      } catch (error) {
        console.error('Failed to delete note:', error);
      }
    }
  };

  const shareOnWhatsApp = (prescriptionId) => {
    const prescriptionToShare = prescription.find(item => item.id === prescriptionId);
    if (prescriptionToShare) {
      const message = `Prescription Details:\n${prescriptionToShare.notes}`;
      const encodedMessage = encodeURIComponent(message);
      const whatsappURL = `https://wa.me/?text=${encodedMessage}`;
      window.open(whatsappURL, '_blank');
    }
  };

  const actions = [
    { label: "View", icon: <View />, onClick: (row) => handleOpenViewDialog(row.prescriptionId) },
    { label: "Share", icon: <Share />, onClick: (row) => shareOnWhatsApp(row.prescriptionId) },
    { label: "Print", icon: <Print />, onClick: (row) => handleOpenViewDialog(row.prescriptionId, 'print') },
    { label: "Download", icon: <Download />, onClick: (row) => handleOpenViewDialog(row.prescriptionId, 'download') },
    // { label: "Delete", icon: <Delete />, onClick: (row) => handleOpenDeleteDialog(row.prescriptionId) },
  ];
  const { isMobile, isTablet, isDesktop } = useResponsive();

  return (
    <>
      <AllTabsMainContainer>
        {(isMobile || isTablet) ?
          <PrescriptionCard
            prescription={prescription}
            page={page}
            perPage={perPage}
            setPage={setPage}
            totalCount={totalCount}
            fetchPrescription={fetchPrescription}
          /> :
          <CustomTable
            key={page}
            columns={columns}
            data={data}
            actions={actions}
            page={page}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            onPerPageChange={(newPerPage) => {
              setPerPage(newPerPage);
              setPage(0);
            }}
            perPage={perPage}
            totalCount={totalCount}
            noDataComponent={
              <NoDataFound
                title="No Prescriptions Found!"
                showButton={false}
                description="No prescriptions recorded by the doctor for this patient yet."
              />
            }
          />
        }

        <DialogBox open={viewDialogOpen} onClose={handleCloseViewDialog} maxWidth="md" fullWidth >
          {selectedPrescriptionId && (
            <ViewPrescription
              prescriptionId={selectedPrescriptionId}
              onClose={handleCloseViewDialog}
              mode={viewMode}
              onActionComplete={handleCloseViewDialog}
            />
          )}
        </DialogBox>



        <DeleteDialog
          open={openDeleteDialog}
          onClose={handleCloseDeleteDialog}
          onConfirm={handleDelete}
          idToDelete={deletePreId}
          title="Delete Prescription"
          message="Are you sure you want to delete this prescription?"
          confirmText="Delete"
        />

      </AllTabsMainContainer>
    </>
  )
};

export default Prescription;

